export const ucasefirst = (str: string): string => {
	if (!str) return str;
	return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

/**
 * Converts a field name to a "set" mutation endpoint name.
 *
 * @example
 * toSetEndpointName('name') // 'setName'
 */
export const toSetEndpointName = (fieldName: string): string => {
	return `set${ucasefirst(fieldName)}`;
};

/**
 * Converts a field name to a "clear" mutation endpoint name.
 *
 * @example
 * toClearEndpointName('name') // 'clearName'
 */
export const toClearEndpointName = (fieldName: string): string => {
	return `clear${ucasefirst(fieldName)}`;
};
